import React, { useEffect, useState } from 'react';
import {
    Breadcrumbs,
    Button,
    Card,
    Divider,
    Grid,
    IconButton,
    Table,
    Typography,
} from '@mui/joy';
import { Link } from 'react-router-dom';
import { CLayout } from '../../components';
import { destroy, get } from '../../api/api';
import './style.scss';
import { Add, ChevronRight, Delete, Visibility } from '@mui/icons-material';
import { Pagination } from '@mui/material';
import { jwtDecode } from 'jwt-decode';

interface SubscriptionPlan {
    id: number;
    name: string;
    stripe_plan_id: string;
}

export const VAbonnements: React.FC = () => {
    const [plans, setPlans] = useState<SubscriptionPlan[]>([]);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);

    const fetchPlans = () => {
        void get({ url: `subscription_plans?page=${page}` })
            .then((res) => {
                // Récupère le header Content-Range (ex: "0-20/100")
                const contentRange =
                    res.headers.get('Content-Range') || res.headers['content-range'];
                if (contentRange) {
                    const total = parseInt(contentRange.split('/')[1], 10);
                    setTotalPages(Math.ceil(total / 20)); // Supposons une taille de page de 20
                }
                setPlans(res.data);
            })
            .catch((err) => console.log(err));
    };

    const deleteAbonnement = (id: string) => {
        if (
            window.confirm(
                "Êtes-vous sûr de vouloir retirer ce plan d'abonnement ?"
            )
        ) {
            void destroy({ url: `subscription_plans/${id}` })
                .then(() => {
                    setPlans((prevPlans) =>
                        prevPlans.filter((plan) => plan.id !== parseInt(id, 10))
                    );
                })
                .catch((err) => console.log(err));
        }
    };

    const handlePageChange = (_e: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    useEffect(() => {
        // Vérifie que l'utilisateur est admin
        const token = localStorage.getItem('token') || '';
        const decode: any = jwtDecode(token);
        if (!decode.roles.includes('ROLE_ADMIN')) {
            window.location.href = '/';
        }
        fetchPlans();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    return (
        <CLayout>
            <section id="VAbonnements">
                <Card className="rounded-none my-4 drop-shadow-lg" variant="outlined">
                    <Grid container spacing={2} className="!items-center">
                        <Grid xs={8}>
                            <Breadcrumbs separator={<ChevronRight fontSize="small" />}>
                                <Link to="/">Eeven PRO</Link>
                                <Typography component="span" level="body-md">
                                    Plan d'abonnements
                                </Typography>
                            </Breadcrumbs>
                        </Grid>
                        <Grid xs={4} sx={{ textAlign: 'end' }}>
                            <Button onClick={() => (window.location.href = '/plans/create')}>
                                <Add /> Ajouter un plan
                            </Button>
                        </Grid>
                    </Grid>
                </Card>

                <Grid container spacing={2} className="justify-between items-center">
                    <Grid xs={4}>
                        <Typography
                            component="h2"
                            level="h4"
                            className="!mt-2 !text-3xl !text-black"
                        >
                            Plan d'abonnements
                        </Typography>
                        <Divider className="!w-[85%] !bg-black !h-[2px] !mt-1 !mb-4" />
                    </Grid>
                </Grid>

                <Table>
                    <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Stripe ID</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {plans.map((plan) => (
                        <tr key={plan.id}>
                            <td>{plan.name}</td>
                            <td>{plan.stripe_plan_id}</td>
                            <td>
                                <IconButton
                                    onClick={() =>
                                        (window.location.href = `/plans/show?id=${plan.id}`)
                                    }
                                >
                                    <Visibility />
                                </IconButton>
                                <IconButton onClick={() => deleteAbonnement(plan.id.toString())}>
                                    <Delete />
                                </IconButton>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>

                <Grid container sx={{ mt: 2, justifyContent: 'center' }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        shape="rounded"
                    />
                </Grid>
            </section>
        </CLayout>
    );
};